module.exports = __webpack_public_path__ + "img/GR011.e3c9245f.png";